const getters = {
    getWorkedHours: (state) => {
        return _.toArray(state.workedHours);
    },

    getWorkedHoursOfCustomerId: (state) => (customerId) => {
        return _.filter(state.workedHours, {'customerId': customerId});
    },
    getWorkedHoursOfPlacementId: (state) => (placementId) => {
        return _.filter(state.workedHours, {'placementId': placementId});
    },
    getWorkedHoursOfPlacementIds: (state) => (placementIds) => {
        return _.filter(state.workedHours, workedHour => {
            return _.includes(placementIds, workedHour.placementId)
        });
    },

}

export default getters